import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import BlueButton from "./BlueButton";
import { Menu, X, ChevronDown, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import ProductPopUP from "./ProductPopUP";
import { headerConfig } from "../utility/constand";

const products = [
  {
    imgSrc: "/images/Frame (1).svg",
    name: "BounceProof",
    description: "Validate emails before you send.",
    comingSoon: false,
    bgColor: "#FFF7EE",
    iconColor: "#FF8A00",
    link: "/bounce-proof",
  },
  {
    imgSrc: "/images/Frame (2).svg",
    name: "IDProof",
    description: "Verify identity. Build trust.",
    comingSoon: false,
    bgColor: "#FFF5F6",
    iconColor: "#FF3D71",
    link: "/id-proof",
  },
  {
    imgSrc: "/images/Frame (3).svg",
    name: "TamperProof",
    description: "If a document has been changed, you'll know.",
    comingSoon: false,
    bgColor: "#FFF3FE",
    iconColor: "#8B5CF6",
    link: "/tamper-proof",
  },
  {
    imgSrc: "/images/Frame (5).svg",
    name: "Finnalyzer",
    description: "Analyse financial statements.",
    comingSoon: false,
    bgColor: "#F4FFE7",
    iconColor: "#84CC16",
    link: "/finnalyzer",
  },
  {
    imgSrc: "/images/Frame (4).svg",
    name: "OCRProof",
    description: "Turn documents into data.",
    comingSoon: true,
    bgColor: "#F1FFFC",
    iconColor: "#10B981",
  },
  {
    imgSrc: "/images/Frame (6).svg",
    name: "Trustiify",
    description: "Confidence with trusted identity score.",
    comingSoon: true,
    bgColor: "#EEFCFF",
    iconColor: "#06B6D4",
  },
];

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const { pathname } = useLocation();

  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const config = headerConfig[location.pathname] || headerConfig["/"];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setIsMobileProductsOpen(false);
    }
  };

  const toggleProductPopup = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleMobileProducts = () => {
    setIsMobileProductsOpen(!isMobileProductsOpen);
  };

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } else {
      alert(`this id not found in current page ${id}`);
    }
  };

  const handleProductClick = (link, event) => {
    if (link) {
      navigate(link.link);
    }
    setIsExpanded(false);
    setIsOpen(false);
  };
  // redirect handler
  const handleRedirect = (url) => {
    window.location.href = url;
  };
  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    function handleClickAnywhere(event) {
      // Close popup if click is outside the popup
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    }

    document.addEventListener("click", handleClickAnywhere);

    return () => {
      document.removeEventListener("click", handleClickAnywhere);
    };
  }, []);

  return (
    <>
      <header className="header-container">
        {/* normal without animate */}
        {/* <div className="befiscname">
          <img
            src="/images/leftwing.png"
            width={15}
            height={15}
            alt="leftwing"
            className="desktop-view-header"
            loading="lazy"
          />
          <span>
            BeFiSc wins the <br className="mobile-header-br" />
            <span style={{ color: "#B6FF00" }}>
              Fintech Innovation of the Year{" "}
            </span>
            Award 🎉
          </span>
          <img
            src="/images/bwimage.png"
            alt="bwimage"
            style={{ width: "6rem" }}
            className="desktop-header-images"
            loading="lazy"
          />
          <img
            src="/images/rightwing.png"
            width={15}
            height={15}
            alt="rightwing"
            className="desktop-header-images"
            loading="lazy"
          />
          <div className="mobile-view-header-images">
            <img
              src="/images/leftwing.png"
              width={15}
              height={15}
              alt="leftwing"
              className="mobile-view-header"
              loading="lazy"
            />
            <img
              src="/images/bwimage.png"
              alt="bwimage"
              style={{ width: "4rem" }}
              loading="lazy"
            />
            <img
              src="/images/rightwing.png"
              width={15}
              height={15}
              alt="rightwing"
              loading="lazy"
            />
          </div>

          <img
              src="/images/leftwing.png"
              width={15}
              height={15}
              alt="leftwing"
              className="desktop-view-header"
              loading="lazy"
            />
            <span>
              🎉 Join us at <br className="mobile-header-br" />
              <span style={{ color: "#B6FF00" }}>
                Global Fintech Fest 2025{" "}
              </span>
              🎉
            </span>
            <img
              src="/images/bwimage.png"
              alt="bwimage"
              style={{ width: "6rem" }}
              className="desktop-header-images"
              loading="lazy"
            />
            <img
              src="/images/rightwing.png"
              width={15}
              height={15}
              alt="rightwing"
              className="desktop-header-images"
              loading="lazy"
            />
        </div> */}

        {/* animate for gff */}
        <div className="befiscname">
          <div className="befiscname-content">
              <img
                src="/images/leftwing.png"
                width={15}
                height={15}
                alt="leftwing"
              />
              <span>
                BeFiSc wins the <br className="mobile-header-br" />
                <span style={{ color: "#B6FF00" }}>
                  Fintech Innovation of the Year
                </span>{" "}
                Award 🎉
              </span>
              <img
                src="/images/bwimage.png"
                alt="bwimage"
                style={{ width: "6rem" }}
              />
              <img
                src="/images/rightwing.png"
                width={15}
                height={15}
                alt="rightwing"
              />
            </div>
        </div>

        <nav className="header-navbar" style={{ position: "relative" }}>
          <Link to={"/"}>
            <img src="/images/befiscsymbol.svg" alt="befisc" className="logo" />
          </Link>

          <div
            className="hamburger-icon"
            onClick={toggleMenu}
            aria-label="Toggle Menu"
          >
            {!isOpen && (
              <div>
                <Menu size={25} color="#000" />
              </div>
            )}
          </div>

          {/* Desktop Navigation */}
          <ul className={`nav-list`}>
            <li
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.2rem",
                position: "relative",
              }}
              ref={dropdownRef}
            >
              <div
                className={
                  selectedTab && pathname !== "/"
                    ? "products-button selected"
                    : "products-button"
                }
                onClick={toggleProductPopup}
                style={{ cursor: "pointer", position: "relative" }}
              >
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedTab(true);
                  }}
                >
                  Products
                </span>
                {!isExpanded && (
                  <ChevronDown
                    className="chevron-icon"
                    width={"1rem"}
                    height={"1rem"}
                    color="#170046"
                  />
                )}
                {isExpanded && (
                  <ChevronUp
                    className="chevron-icon"
                    width={"1rem"}
                    height={"1rem"}
                    color="#170046"
                  />
                )}
              </div>
            </li>

            <li>
              <a
                href="https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com"
                target="_blank"
                rel="noreferrer"
              >
                Newsletter
              </a>
            </li>
            <li>
              <a
                href="https://web.befisc.com/fintechsherlock/article/"
                rel="noreferrer"
              >
                Blog
              </a>
            </li>
          </ul>

          <div className="desktop-demo-button">
            {config.type === "demo" && (
              <BlueButton
                text="Book a Demo"
                onClick={() => handleScroll(config.scroll_to)}
              />
            )}

            {config.type === "auth" && (
              <BlueButton
                text="Login / Signup"
                onClick={() => handleRedirect(config.redirect_url)}
              />
            )}
          </div>
        </nav>

        {/* Mobile Menu Overlay */}
        <div
          className={`mobile-menu-overlay ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
        ></div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? "active" : ""}`}>
          <div className="mobile-menu-header">
            <h2>Menu</h2>
            <button className="mobile-menu-close" onClick={toggleMenu}>
              <X size={24} color="#000" />
            </button>
          </div>

          <div className="mobile-menu-content">
            <div className="mobile-menu-section">
              <div
                className="mobile-menu-item mobile-products-toggle"
                onClick={toggleMobileProducts}
              >
                <span>Products</span>
                <ChevronDown
                  size={20}
                  className={`chevron ${isMobileProductsOpen ? "rotated" : ""}`}
                />
              </div>

              <div
                className={`mobile-products-list ${
                  isMobileProductsOpen ? "expanded" : ""
                }`}
              >
                {products.map((product, index) => (
                  <div
                    key={index}
                    className="mobile-product-card"
                    style={{ backgroundColor: product.bgColor }}
                    onClick={() => handleProductClick(product)}
                  >
                    <div className="mobile-product-info">
                      <div className="mobile-product-icon">
                        <div className="product-icon-circle">
                          <img src={product.imgSrc} alt={product.name} />
                        </div>
                      </div>
                      <div className="mobile-product-details">
                        <div className="mobile-product-name">
                          {product.name}
                        </div>
                        <div className="mobile-product-description">
                          {product.description}
                        </div>
                      </div>
                    </div>
                    <div className="mobile-product-action">
                      {product.comingSoon ? (
                        <div className="mobile-coming-soon">Coming Soon</div>
                      ) : (
                        <img src="" alt="" />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mobile-menu-section">
              {/* <div className="mobile-menu-item">
                <span>About Us</span>
              </div> */}
              <div className="mobile-menu-item">
                <a
                  href="https://web.befisc.com/fintechsherlock/article/"
                  rel="noreferrer"
                >
                  Blogs
                </a>
              </div>
              <div className="mobile-menu-item">
                <a
                  href="https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Newsletter
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ProductPopUP for desktop */}
      <ProductPopUP
        isExpanded={isExpanded}
        onProductClick={handleProductClick}
      />
    </>
  );
}

export default Header;
